import {
  FeatureName,
  RadioQuestionConfig,
  RadioState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { useController } from 'react-hook-form';
import { ControlledRadioButtons } from '../../../../../components/forms';
import { Colors } from '../../../../../themes/colors';
import { useFormContext } from '../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const RadioQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  RadioQuestionConfig,
  RadioState
> = (
  props: RoutineQuestionExecutionFormProps<RadioQuestionConfig, RadioState>
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.option ?? []
    : [];
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.option`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledRadioButtons
      control={control}
      name={field.name}
      color={Colors.blue}
      options={props.config.options.map((option) => {
        return {
          value: option,
        };
      })}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to RadioQuestionExecutionFormBase after feature is fully rolled out
const RadioQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  RadioQuestionConfig,
  RadioState
> = (
  props: RoutineQuestionExecutionFormProps<RadioQuestionConfig, RadioState>
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.option ?? []
    : [];
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.option`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledRadioButtons
      control={control}
      name={field.name}
      color={Colors.blue}
      options={props.config.options.map((option) => {
        return {
          value: option,
        };
      })}
      useCropCircle
    />
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const RadioQuestionExecutionForm: RoutineQuestionExecutionForm<
  RadioQuestionConfig,
  RadioState
> = (
  props: RoutineQuestionExecutionFormProps<RadioQuestionConfig, RadioState>
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <RadioQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to RadioQuestionExecutionFormBase after feature is fully rolled out
  return <RadioQuestionExecutionFormBase {...props} />;
};
